import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { getGeoTag } from "../../CrudOperations/GetOperation";
import AddGeoTag from "./AddGeoTag";
import { fa5, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { UpdateGeoTag } from "../../CrudOperations/Update&Edit";

const GeoTag = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredGeoTagIntervals, setFilteredGeoTagIntervals] = useState([]);
  const [GeoTagIntervals, setGeoTagIntervals] = useState([]);
  const [edit, setEdit] = useState("");

  useEffect(() => {
    const fetchStaffs = async () => {
      const response = await getGeoTag();

      console.log(response);

      if (response.data.length > 0) {
        console.log(response.data);
        setGeoTagIntervals(response.data);
        setFilteredGeoTagIntervals(response.data);
      }
    };
    fetchStaffs();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = GeoTagIntervals.filter(
      (p) =>
        p.StaffName.toLowerCase().includes(query) ||
        p.SkillName.toLowerCase().includes(query)
    );
    setFilteredGeoTagIntervals(filteredList);
  };

  const handleAddStaffformClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEdit("");
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    const response = await getGeoTag();

    console.log(response);

    if (response.data.length > 0) {
      console.log(response.data);
      setGeoTagIntervals(response.data);
      setFilteredGeoTagIntervals(response.data);

      setEdit("");
      setIsModalOpen(false);
    }
  };

    const handleUpdateStaff = async (p) => {
    setEdit(p);

    setIsModalOpen(true);
  };

  const handleUpdate = (newStaff) => {
    console.log("Updated Staff:", newStaff);
    console.log("Editing Staff ID:", edit.id);
    console.log("Staff List:", GeoTagIntervals);

    setGeoTagIntervals((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff, // Keep existing properties
              ...newStaff, // Merge properties from newStaff
            }
          : prevStaff
      )
    );

    setFilteredGeoTagIntervals((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff,
              ...newStaff,
            }
          : prevStaff
      )
    );

    setEdit(null);
    closeModal(); // Close the modal after updating
  };

  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-inter font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Manage Geo Tag
      </h1>

      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-1/2 border border-gray-300 p-3 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />

        <div className="flex items-center gap-4">
          <button
            onClick={handleAddStaffformClick}
            className="bg-blue-600 text-white px-6 py-2 rounded-md flex items-center gap-2 transition-transform duration-200 hover:bg-blue-700 hover:scale-105 shadow-md shadow-blue-500 hover:shadow-lg"
          >
            <FontAwesomeIcon icon={faPlus} />
            Add Geo Tag Interval
          </button>
        </div>
      </div>

      {/* Responsive table wrapper */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-auto border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              {["S.No", "Event Name", "Interval", "Status","Edit"].map((heading) => (
                <th
                  key={heading}
                  className="py-3 px-4 text-center font-semibold text-gray-700"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {console.log(filteredGeoTagIntervals)}
            {filteredGeoTagIntervals.length > 0 ? (
              filteredGeoTagIntervals.map((p, index) => (
                <tr
                  key={index}
                  className="border-b transition-colors duration-200 hover:bg-gray-50"
                >
                  <td className="py-3 px-4 text-center">{index + 1}</td>
                  <td className="py-3 px-4 text-center">{p.EventName}</td>
                  <td className="py-3 px-4 text-center">
                    {p.IntervalInMinutes}
                  </td>
                  <td className="py-3 px-4 text-center">
                    {p.Status === 0 ? "InActive" : "Active"}
                  </td>
                    <td className="py-3 px-4 text-center">
                       <button
                        onClick={() => handleUpdateStaff(p,"Edit")}
                        className="text-blue-500 transition-colors duration-200 hover:text-blue-700"
                      >
                      <FontAwesomeIcon icon={faPen} />
                      </button>
                      </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="py-3 text-center text-gray-600">
                  No Staffs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add Staff Modal */}
      {isModalOpen && (
        <AddGeoTag
          closeModal={closeModal}
          onSubmit={handleSubmit}
          alloteDuty={edit}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default GeoTag;
